import { Button, ButtonProps, Heading } from '@purpur/library';
import styled, { css } from 'styled-components';

import {
    getPurpurBorder,
    getPurpurColor,
    getPurpurSpacing,
    getPurpurTypography,
    purpurMedia,
} from '@telialt/common-theme/src/purpurSelectors';

import { ExpansionModeAttr } from '../../model';
import { sideSpacingOfHeaderFooter } from '../../OrderCart.styles';

export const ExpandButton = styled(Button).attrs<Partial<ButtonProps>>({ variant: 'text' })`
    padding: ${getPurpurSpacing('200')} 0;
    gap: ${getPurpurSpacing('100')};
    line-height: ${getPurpurSpacing('200')};
`;

export const Title = styled(Heading)`
    font-size: ${getPurpurTypography('scale100')};
    ${purpurMedia('lg')`
        font-size: ${getPurpurTypography('scale200')};
    `}
`;

const headerExpandableStyles = css`
    padding-top: ${getPurpurSpacing('100')};
    padding-bottom: ${getPurpurSpacing('100')};
`;
const headerStaticStyles = css`
    padding-top: ${getPurpurSpacing('200')};
    padding-bottom: ${getPurpurSpacing('200')};

    ${purpurMedia('lg')`
        padding-top: ${getPurpurSpacing('250')};
        padding-bottom: ${getPurpurSpacing('250')};
    `}
`;

export const CartBoxHeader = styled.div<ExpansionModeAttr>(
    ({ $expansionMode }) => css`
        ${$expansionMode === 'NEVER' &&
        css`
            background: ${getPurpurColor('backgroundPrimary')};
            justify-content: center;
            ${ExpandButton} {
                display: none;
            }
            ${headerStaticStyles}
        `}
        ${$expansionMode === 'ALWAYS' &&
        css`
            background: ${getPurpurColor('backgroundSecondary')};
            justify-content: space-between;
            ${ExpandButton} {
                display: inline-flex;
            }
            ${headerExpandableStyles}
        `}
        ${$expansionMode === 'MOBILE_ONLY' &&
        css`
            ${purpurMedia('sm')`
                background: ${getPurpurColor('backgroundSecondary')};
                justify-content: space-between;
                ${ExpandButton} { 
                    display: inline-flex;
                }
                ${headerExpandableStyles}
            `}
            ${purpurMedia('md')`
                background: ${getPurpurColor('backgroundPrimary')};
                justify-content: center;
                ${ExpandButton} { 
                    display: none;
                }
                ${headerStaticStyles}
            `}
        `};

        display: flex;
        line-height: ${getPurpurSpacing('600')};
        align-items: center;

        ${sideSpacingOfHeaderFooter};
        border-bottom: ${getPurpurBorder('widthXs')} solid ${getPurpurColor('borderMedium')};
    `,
);
